import { render } from "./EmptyLayout.vue?vue&type=template&id=5a95cb27&scoped=true"
const script = {}

import "./EmptyLayout.vue?vue&type=style&index=0&id=5a95cb27&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a95cb27"]])

export default __exports__